const ProfileModal = ({ profile, sender, messagingService, onClose }) => {
  const renderDetailRow = (key, value, level = 0) => {
    const isObject =
      value !== null && typeof value === "object" && !Array.isArray(value);
    return (
      <div key={key} className={`mb-2 ml-4`}>
        <span className="text-blue-400 font-medium">{key}:</span>{" "}
        {isObject ? (
          <div className="mt-1 pl-2 border-l border-gray-600">
            {Object.entries(value).map(([subKey, subValue]) =>
              renderDetailRow(subKey, subValue, level + 1),
            )}
          </div>
        ) : (
          <span className="text-green-300">
            {value === null
              ? "null"
              : value === undefined
                ? "undefined"
                : String(value)}
          </span>
        )}
      </div>
    );
  };

  const renderSection = (label, data) => (
    <div className="text-gray-300">
      <div>{label}:</div>
      <div className="bg-gray-700 p-4 max-h-80 rounded-md overflow-y-auto dark-slim-scrollbar">
        {data ? (
          Object.entries(data).map(([key, value]) =>
            renderDetailRow(key, value),
          )
        ) : (
          <span className="text-gray-500 italic">Not available</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="flex flex-col bg-gray-800 p-6 rounded-lg w-full max-w-4xl m-4 shadow-xl max-h-[80vh] ">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-white">
            Profile Details:{" "}
          </h2>
        </div>
        <div className="flex mb-4 space-y-2 h-full overflow-y-auto dark-slim-scrollbar">
          <div className="flex-grow-1 overflow-y-auto">
            {renderSection("Customer Profile", profile)}
            {renderSection("Sender", sender)}
            {renderSection("Messaging Service", messagingService)}
          </div>
        </div>
        <button
          onClick={() => onClose()}
          className="flex items-end w-fit px-4 py-2 bg-red-600 text-white rounded hover:bg-red-500 transition-colors duration-150"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ProfileModal;
